import React from 'react';
import './Services.css';

export const services = [
  { title: 'Dog Walking', description: 'Daily walks tailored to your dog’s needs.', price: '$1/walk' },
  { title: 'House Sitting', description: 'Safe and comfortable overnight care.', price: '$60/night' },
  { title: 'Drop-In Visit', description: 'Quick check-ins for feeding, play, and potty breaks.', price: '$18/visit' },
  { title: 'Pet Day Care', description: 'Special attention for puppies, kittens, and other young pets.', price: '$25/day' }
];

const Services = ({ selectedIndex, onSelectService }) => {

  return (
    <section className="services">
      <h2>How Can I Help Your Pet?</h2>
      <div className="services-list">
        {services.map((service, idx) => (
          <button
            key={idx}
            type="button"
            className={idx === selectedIndex ? 'service-card selected' : 'service-card'}
            onClick={() => onSelectService(idx)}
          >
            <h3>{service.title}</h3>
            <p>{service.description}</p>
            <div className="service-price" style={{marginTop: '1rem', fontWeight: 'bold', color: '#d6336c'}}>{service.price}</div>
          </button>
        ))}
      </div>
    </section>
  );
};

export default Services;
